// src/components/MenuScreen.js
import React from 'react';
import { Heart, Star } from 'lucide-react';
import AyseLadyLogo from './AyseLadyLogo';

const MenuScreen = ({ onStartGame }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-400 via-purple-500 to-indigo-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 text-center max-w-md w-full">
        <AyseLadyLogo />
        
        <div className="mb-8">
          <div className="text-6xl mb-4">🐱📚</div>
          <h2 className="text-xl text-gray-700 mb-4 leading-relaxed">
            Sevimli kedi arkadaşınla İngilizce öğren! <br/>
            200 soruyla İngilizce kelime hazineni geliştir.
          </h2>
        </div>

        <div className="space-y-4 mb-6">
          <div className="bg-pink-50 p-4 rounded-lg">
            <div className="flex items-center justify-center mb-2">
              <Heart className="w-5 h-5 text-red-500 mr-2" />
              <span className="font-semibold text-gray-700">3 Kalp Hakkın</span>
            </div>
            <p className="text-sm text-gray-600">Yanlış cevaplarda kalp kaybedersin</p>
          </div>
          
          <div className="bg-purple-50 p-4 rounded-lg">
            <div className="flex items-center justify-center mb-2">
              <Star className="w-5 h-5 text-yellow-500 mr-2" />
              <span className="font-semibold text-gray-700">200 Soru</span>
            </div>
            <p className="text-sm text-gray-600">Her doğru cevapla kedin büyür!</p>
          </div>
        </div>

        <button 
          onClick={onStartGame}
          className="w-full bg-gradient-to-r from-pink-500 to-purple-600 text-white py-4 px-6 rounded-xl font-bold text-lg hover:from-pink-600 hover:to-purple-700 transition-all duration-300 shadow-lg transform hover:scale-105"
        >
          🎮 Oyuna Başla
        </button>

        <div className="mt-6 text-xs text-gray-500">
          © 2025 AyseLady.com - İngilizce Öğrenme Platformu
        </div>
      </div>
    </div>
  );
};

export default MenuScreen;